module.exports = "<p>\r\n  voyeurism-free works!\r\n</p>\r\n"